import { render, staticRenderFns } from "./llc-packages.vue?vue&type=template&id=000b6bb2&"
import script from "./llc-packages.vue?vue&type=script&lang=js&"
export * from "./llc-packages.vue?vue&type=script&lang=js&"
import style0 from "./llc-packages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconClock: require('/usr/src/app/components/icons/icon-clock.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,IconClockFast: require('/usr/src/app/components/icons/icon-clock-fast.vue').default})
